import {CookieHelper, HeaderTopMenuController, Task} from "./base";
import {LocalizationManager} from "./localization";

class CookieConsentManager
{
    #modal;
    #acceptBtn;
    #moreLink;
    #title;
    #description;
    #buttonText;

    #cookieAcceptName = 'bo_cookie_accepted';
    #disclaimerAcceptName = 'bo_disclaimer_accepted';

    #isDetailedView = false;
    #isDisclaimerMode = false;
    #isAnimating = false;

    constructor()
    {
        this.#modal = document.getElementById('cookieConsent');

        if (!this.#modal) return;

        this.#acceptBtn = document.getElementById('cookieAccept');
        this.#moreLink = document.querySelector('.cookie-consent__link');
        this.#title = document.querySelector('.cookie-consent__title');
        this.#description = document.querySelector('.cookie-consent__description');
        this.#buttonText = document.querySelector('.cookie-consent__btn .second-btn__text');

        this.#Initialize();
    }

    async #Initialize()
    {
        const cookieAcceptedValue = CookieHelper.GetCookie(this.#cookieAcceptName);

        if (!cookieAcceptedValue || cookieAcceptedValue !== 'true')
        {
            await this.#ShowModalAsync();
        }
        else
        {
            // const disclaimerAcceptedValue = CookieHelper.GetCookie(this.#disclaimerAcceptName);
            //
            // if (!disclaimerAcceptedValue || disclaimerAcceptedValue !== 'true')
            // {
            //     this.#ShowDisclaimer();
            //     await this.#ShowModalAsync();
            // }
        }

        this.#acceptBtn.addEventListener('click', async () => {
            await this.#HandleAcceptClickAsync();
        });

        this.#moreLink.addEventListener('click', (e) => {
            e.preventDefault();
            this.#ShowDetailedText();
        });

        document.addEventListener('keydown', async (e) => {
            if (e.key === 'Escape' && this.#modal.classList.contains('active'))
            {
                await this.#HandleEscapePressAsync();
            }
        });
    }

    async #HandleAcceptClickAsync()
    {
        if (this.#isAnimating) return;

        if (this.#isDisclaimerMode)
        {
            CookieHelper.SetCookie(this.#disclaimerAcceptName, 'true');
            await this.#HideModalAsync();
        }
        else
        {
            this.#AcceptCookies();
            await this.#HideModalAsync();
        }
    }

    async #HandleEscapePressAsync()
    {
        if (this.#isAnimating) return;

        if (this.#isDetailedView)
        {
            this.#HideDetailedText();
        }
        else if (this.#isDisclaimerMode)
        {
            CookieHelper.SetCookie(this.#disclaimerAcceptName, 'true');
            await this.#HideModalAsync();
        }
        else
        {
            await this.#HideModalAsync();
        }
    }

    async #ShowModalAsync()
    {
        if (this.#modal.classList.contains('active')) return;

        this.#isAnimating = true;
        await Task.Delay(1000);

        this.#modal.classList.add('active');
        await Task.Delay(100);

        this.#modal.classList.add('visible');
        this.#isAnimating = false;
    }

    async #HideModalAsync()
    {
        if (this.#isAnimating) return;

        this.#isAnimating = true;
        this.#modal.classList.remove('visible');

        await Task.Delay(100);

        this.#modal.classList.remove('active');
        this.#isAnimating = false;
    }

    #ShowDetailedText()
    {
        if (this.#isAnimating) return;
        this.#isDetailedView = true;
        this.#description.innerHTML = LocalizationManager.GetText("cookie_additional_desc_html");
        this.#moreLink.style.display = 'none';
    }

    #HideDetailedText()
    {
        if (this.#isAnimating) return;
        this.#isDetailedView = false;
        this.#description.textContent = LocalizationManager.GetText("cookie_desc");
        this.#moreLink.style.display = 'block';
    }


    // #ShowDisclaimer()
    // {
    //     if (this.#isAnimating) return;
    //     this.#isDisclaimerMode = true;
    //     this.#title.textContent = LocalizationManager.GetText("disclaimer_title");
    //     this.#description.textContent = LocalizationManager.GetText("disclaimer_desc");
    //     this.#moreLink.style.display = 'none';
    //     this.#buttonText.textContent = LocalizationManager.GetText("close_btn");
    // }

    #AcceptCookies()
    {
        if (this.#isAnimating) return;

        CookieHelper.SetCookie(this.#cookieAcceptName, 'true');
        // this.#ShowDisclaimer();
    }
}

class MainPage
{
    static Main()
    {
        HeaderTopMenuController.HighlightItem("nav-start-game");

        new CookieConsentManager();
    }
}

document.addEventListener('DOMContentLoaded', MainPage.Main);